import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'
import BaseVideoEmbedDefaults from  '../BaseVideoEmbed.defaults'
import BasePlayButtonDefaults from  '../BasePlayButton/BasePlayButton.defaults'

export default  {
  ...cloneDeep(baseDefaults),
  video: cloneDeep(BaseVideoEmbedDefaults),
  playButton: cloneDeep(BasePlayButtonDefaults)
}

